export default angular.module('syDate', [])
/**
         * @ngdoc directive
         * @name syDate.directive:syDate
         * @description
         * Creates a controller to track a date input field.
         */
// @ngInject
    .directive('syDate', ['$document', '$q', '$filter', '$timeout', function ($document, $q, $filter, $timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: true,
            link: function ($scope, $element, attrs, ngModel) {
                var minDate;
                var maxDate;

                // Set parser
                ngModel.$parsers.unshift(function (data) {
                    if (!data) {
                        return data;
                    }

                    if (typeof data === 'string' && data.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                        var comp = data.split('/');
                        var tempDay = parseInt(comp[0]);
                        var tempMonth = parseInt(comp[1]);
                        var tempYear = parseInt(comp[2]);

                        return tempMonth < 1 || tempMonth > 12 ? undefined : new Date(tempYear, tempMonth - 1, tempDay);
                    }

                    return undefined;
                });

                // Set formatter
                ngModel.$formatters.push(function (data) {
                    return $filter('date')(data, 'dd/MM/yyyy');
                });

                // Min date validation
                if (angular.isDefined(attrs.min) || attrs.ngMin) {
                    ngModel.$validators.min = function (modelValue) {
                        if (angular.isDate(modelValue) && angular.isDate(minDate)) {
                            return modelValue >= minDate;
                        }

                        return true;
                    };

                    attrs.$observe('min', function (val) {
                        if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                            var comp = val.split('/');
                            var tempDay = parseInt(comp[0]);
                            var tempMonth = parseInt(comp[1]);
                            var tempYear = parseInt(comp[2]);

                            minDate = tempMonth < 1 || tempMonth > 12 ? undefined : new Date(tempYear, tempMonth - 1, tempDay);
                        }
                        ngModel.$validate();
                    });
                }

                // Max date validation
                if (angular.isDefined(attrs.max) || attrs.ngMax) {
                    ngModel.$validators.max = function (modelValue) {
                        if (angular.isDate(modelValue) && angular.isDate(maxDate)) {
                            return modelValue <= maxDate;
                        }

                        return true;
                    };

                    attrs.$observe('max', function (val) {
                        if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                            var comp = val.split('/');
                            var tempDay = parseInt(comp[0]);
                            var tempMonth = parseInt(comp[1]);
                            var tempYear = parseInt(comp[2]);

                            maxDate = tempMonth < 1 || tempMonth > 12 ? undefined : new Date(tempYear, tempMonth - 1, tempDay);
                        }
                        ngModel.$validate();
                    });
                }

                // Append the calendar button
                var calendarButton = angular.element('<button type="button" class="form-input form-input--datepicker-toggle" aria-label="Choose Date">');

                // Append the calendar popup control
                var popupCalendar = {
                    defered: undefined,
                    element: angular.element("<div class='datepicker'>" +
                        "<div class='datepicker-nav'>" +
                        "<button type='button' class='datepicker-button datepicker-button--prev'>" +
                        "<div class='form-input--screen-reader'>Previous month</div>" +
                        "</button>" +
                        "<span class='datepicker-title'></span>" +
                        "<button type='button' class='datepicker-button datepicker-button--next'>" +
                        "<div class='form-input--screen-reader'>Previous month</div>" +
                        "</button>" +
                        "</div>" +
                        "<div class='datepicker-days'>" +
                        "<div class='weekdays'>" +
                        "<span class='day day--weekday'>M</span><span class='day day--weekday'>T</span><span class='day day--weekday'>W</span><span class='day day--weekday'>T</span><span class='day day--weekday'>F</span><span class='day day--weekday'>S</span><span class='day day--weekday'>S</span>" +
                        "</div>" +
                        "<div class='days'>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "<a class='day'></a>" +
                        "</div>" +
                        "</div>" +
                        "</div>"),
                    header: undefined,
                    prevButton: undefined,
                    nextButton: undefined,
                    days: undefined,
                    activate: function (dateValue, minDate, maxDate) {
                        var self = this;
                        var date = null;
                        if (typeof dateValue === 'string' && dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                            var comp = dateValue.split('/');
                            var tempDay = parseInt(comp[0]);
                            var tempMonth1 = parseInt(comp[1]);
                            var tempYear1 = parseInt(comp[2]);

                            date = tempMonth1 < 1 || tempMonth1 > 12 ? null : new Date(tempYear1, tempMonth1 - 1, tempDay);
                        }

                        // Set the selected day
                        self.selectedDay = date;

                        // Set the focus month
                        var tempDate = date ? date : new Date();
                        var tempMonth = tempDate.getMonth();
                        var tempYear = tempDate.getFullYear();
                        self.focusMonth = new Date(tempYear, tempMonth, 1);

                        // Set the min/max dates
                        self.minDay = minDate ? minDate : null;
                        self.maxDay = maxDate ? maxDate : null;

                        self.defered = $q.defer();

                        // Create the bound deactivate function
                        $timeout(function () {
                            $document.one('click', { self: self, defered: self.defered }, self.deactivate);
                        });

                        // Render the calendar
                        self.render();
                        self.element.addClass('datepicker--active');

                        return self.defered.promise;
                    },
                    deactivate: function (evt) {
                        if (evt.data.defered === evt.data.self.defered) {
                            evt.data.self.element.removeClass('datepicker--active');
                            evt.data.defered.reject('cancelled');
                        }
                    },
                    render: function () {
                        var self = this;

                        // Set the header
                        var tempMonth = self.focusMonth.getMonth();
                        var tempYear = self.focusMonth.getFullYear();
                        var header = '';
                        if (tempMonth === 0) {
                            header = 'January';
                        } else if (tempMonth === 1) {
                            header = 'February';
                        } else if (tempMonth === 2) {
                            header = 'March';
                        } else if (tempMonth === 3) {
                            header = 'April';
                        } else if (tempMonth === 4) {
                            header = 'May';
                        } else if (tempMonth === 5) {
                            header = 'June';
                        } else if (tempMonth === 6) {
                            header = 'July';
                        } else if (tempMonth === 7) {
                            header = 'August';
                        } else if (tempMonth === 8) {
                            header = 'September';
                        } else if (tempMonth === 9) {
                            header = 'October';
                        } else if (tempMonth === 10) {
                            header = 'November';
                        } else if (tempMonth === 11) {
                            header = 'December';
                        }
                        header += ' ' + tempYear;
                        self.header.text(header);

                        // Enable/disable next/previous month buttons
                        self.prevButton.attr('disabled', false);
                        self.nextButton.attr('disabled', false);

                        if (self.minDay) {
                            var tempDate1 = new Date(self.focusMonth.getTime() - 86400000);
                            if (tempDate1 < self.minDay) {
                                self.prevButton.attr('disabled', true);
                            }
                        }

                        if (self.maxDay) {
                            var tempDate2 = new Date(tempMonth === 11 ? tempYear + 1 : tempYear, tempMonth === 11 ? 0 : tempMonth + 1, 1);
                            if (tempDate2 > self.maxDay) {
                                self.nextButton.attr('disabled', true);
                            }
                        }

                        // Identify the start of the focus month week
                        var date = new Date(tempYear, tempMonth, 1);
                        while (date.getDay() !== 1) {
                            date = new Date(date.getTime() - 86400000);
                        }

                        // Iterate between all the days and set their properties
                        for (var j = 0; j < self.days.length; j++) {
                            var dayElement = angular.element(popupCalendar.days[j]);
                            var isDiffMonth = date.getMonth() !== tempMonth;
                            var isDisabled = self.minDay && date < self.minDay || self.maxDay && date > self.maxDay;
                            var isSelected = self.selectedDay && self.selectedDay.getDate() === date.getDate() && self.selectedDay.getMonth() === date.getMonth() && self.selectedDay.getFullYear() === date.getFullYear();

                            // Set the properties
                            dayElement.text(date.getDate());
                            dayElement.removeClass('day--active');
                            dayElement.removeClass('day--inactive');
                            dayElement.attr('disabled', false);

                            if (isSelected) {
                                dayElement.addClass('day--active');
                            }

                            if (isDiffMonth) {
                                dayElement.addClass('day--inactive');
                            }

                            if (isDisabled) {
                                dayElement.attr('disabled', true);
                            }

                            // Build the date string
                            var stringDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                            var stringMonth = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                            dayElement.data('dateStr', isDisabled ? '' : stringDate + '/' + stringMonth + '/' + date.getFullYear());

                            // Increment the date
                            date = new Date(date.getTime() + 86400000);
                        }
                    },
                    prevMonth: function (evt) {
                        var date = evt.data.focusMonth;
                        evt.data.focusMonth = new Date(date.getMonth() === 0 ? date.getFullYear() - 1 : date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1, 1);
                        evt.data.render();
                    },
                    nextMonth: function (evt) {
                        var date = evt.data.focusMonth;
                        evt.data.focusMonth = new Date(date.getMonth() === 11 ? date.getFullYear() + 1 : date.getFullYear(), date.getMonth() === 11 ? 0 : date.getMonth() + 1, 1);
                        evt.data.render();
                    },
                    selectDay: function (evt) {
                        if (evt.data.dayElement.data('dateStr')) {
                            evt.data.self.element.removeClass('datepicker--active');
                            evt.data.self.defered.resolve(evt.data.dayElement.data('dateStr'));
                            evt.data.self.defered = null;
                        }
                    }
                };
                popupCalendar.element.on('click', function (evt) {
                    evt.stopPropagation();
                });
                popupCalendar.header = angular.element(popupCalendar.element.find('span')[0]),
                popupCalendar.prevButton = angular.element(popupCalendar.element.find('button')[0]),
                popupCalendar.nextButton = angular.element(popupCalendar.element.find('button')[1]),
                popupCalendar.days = popupCalendar.element.find('a'),

                popupCalendar.prevButton.on('click', popupCalendar, popupCalendar.prevMonth);
                popupCalendar.nextButton.on('click', popupCalendar, popupCalendar.nextMonth);
                for (var i = 0; i < popupCalendar.days.length; i++) {
                    var dayElement = angular.element(popupCalendar.days[i]);
                    dayElement.on('click', { self: popupCalendar, dayElement: dayElement }, popupCalendar.selectDay);
                }

                calendarButton.on('click', function () {
                    if (!$element[0].disabled) {
                        // Pass in the view value (even though it may not be valid)
                        var promise = popupCalendar.activate(ngModel.$viewValue, minDate, maxDate);
                        promise.then(function (value) {
                            ngModel.$setViewValue(value);
                            ngModel.$render();
                        });
                    }
                });

                $element.after(calendarButton);
                calendarButton.after(popupCalendar.element);
            }
        };
    }]);
